import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Skeleton from '@zenbusiness/zui/Skeleton';
import Stack from '@zenbusiness/zui/Stack';

import { FocusGrid, ContainerGrid } from '#client/components/Grid';
import useBreakpoints from '#client/hooks/useBreakpoints';

import { Wrapper, SnackbarContentStyled, PaperStyled } from './DataWeHaveSkeleton.styles';
import InfoCardSkeleton from './InfoCardSkeleton';

export default function DataWeHaveSkeleton() {
  const {
    sizes: { isDesktop }
  } = useBreakpoints();

  return (
    <ContainerGrid
      paddingBottom="48px"
      paddingTop="48px"
    >
      <FocusGrid justifyItems="initial">
        <Wrapper>
          <Stack
            direction="column"
            spacing="12px"
            width="100%"
          >
            <Skeleton height={isDesktop ? 44 : 56} />
            <Skeleton height={isDesktop ? 56 : 40} />
          </Stack>
          <SnackbarContentStyled message="Gathering your info for you..." />

          <PaperStyled
            elevation={0}
            variant="outlined"
          >
            <InfoCardSkeleton
              icon={
                <SharedAsset
                  alt=""
                  height={28}
                  src="/icon/misc/bullet-business.svg"
                  width={28}
                />
              }
              title="Business Details"
              totalLeftFields={3}
              totalRightFields={4}
            />
            <InfoCardSkeleton
              icon={
                <SharedAsset
                  alt=""
                  height={28}
                  src="/icon/misc/bullet-owner.svg"
                  width={28}
                />
              }
              title="Account Owner"
              totalLeftFields={3}
              totalRightFields={3}
            />
          </PaperStyled>
        </Wrapper>
      </FocusGrid>
    </ContainerGrid>
  );
}
